<template>
  <div class="navDiv1" id="topheader1" :key="$route.path">
    <nav
      class="navbar navbar-expand-md navbar-light MobileHide gamesNav1"
      style="height: 45px"
    >
      <button
        class="navbar-toggler"
        type="button"
        style="margin-bottom: 5px; border: none"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav1">
        <ul class="navbar-nav" style="">
          <li class="nav-item">
            <router-link
              style="color: #e6e6e6"
              class="active"
              id="routerLink1"
              to="/Today"
            >
              <span class="kek2">{{ $t("LanguageEn.tabToday") }} </span>
              <span v-if="gameC > 9" style="">
                <span
                  style="
                    background: #43a047;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'Today'"
                  >{{ gameC | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameC | transliterate(cookiesObject.lang) }}</span
                >
              </span>
              <span v-else>
                <span
                  style="
                    background: #43a047;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'Today'"
                  >{{ gameC | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameC | transliterate(cookiesObject.lang) }}</span
                >
              </span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link style="color: #e6e6e6" id="routerLink1" to="/Live">
              <span class="kek1">{{ $t("LanguageEn.tabLive") }}</span>
              <span v-if="gameCL > 9">
                <span
                  style="
                    background: #d04959;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'Live'"
                  >{{ gameCL | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameCL | transliterate(cookiesObject.lang) }}</span
                >
              </span>
              <span v-else>
                <span
                  style="
                    background: #d04959;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'Live'"
                  >{{ gameCL | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameCL | transliterate(cookiesObject.lang) }}</span
                >
              </span>
            </router-link>
          </li>
          <li class="nav-item" v-if="cookiesObject.token">
            <router-link style="color: #e6e6e6" id="routerLink1" to="/MyGames"
              ><span class="kek3"> {{ $t("LanguageEn.tabMyGames") }} </span>
              <span v-if="gameCF > 9">
                <span
                  style="
                    background: #be8733;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'MyGames'"
                  >{{ gameCF | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameCF | transliterate(cookiesObject.lang) }}</span
                >
              </span>
              <span v-else>
                <span
                  style="
                    background: #be8733;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-if="$route.name == 'MyGames'"
                  >{{ gameCF | transliterate(cookiesObject.lang) }}</span
                >
                <span
                  style="
                    background: #707070;
                    font-size: 11px;
                    padding-left: 5px;
                    padding-right: 5px;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    border-radius: 50%;
                    margin-left: 2px;
                  "
                  v-else
                  >{{ gameCF | transliterate(cookiesObject.lang) }}</span
                >
              </span>
            </router-link>
          </li>
          <li class="nav-item" v-else>
            <div
              id="routerLink1"
              to="/MyGames"
              style="cursor: pointer"
              data-toggle="modal"
              data-target="#exampleModal"
            >
              <span class="kek3"> {{ $t("LanguageEn.tabMyGames") }} </span>
            </div>
          </li>
          <!-- <li class="nav-item ">
                    <router-link class="kek1" id="routerLink1" to="/Scheduled">SCHED </router-link> 
                  </li> -->
        </ul>
      </div>
    </nav>
    <div style="color: black">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "NavbarLinks",
  data() {
    return {
      value: "",
      ssize: "",
      cookiesObject: "",
    };
  },

  mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    window.addEventListener("resize", this.nowSize);
    this.nowSize();
  },

  destroyed() {
    window.removeEventListener("resize", this.nowSize);
  },

  methods: {
    ...mapActions(["setdateNtime"]),
    setLIDs() {
      this.setdateNtime(this.dateIden);
    },
    nowSize() {
      this.ssize = window.innerWidth;
    },
    redirect() {
      if (this.value != undefined) {
        this.$router.push({ name: "Finished", params: { dateS: this.value } });
      }
    },
  },

  props: {},

  computed: {
    ...mapGetters(["dateNtime", "gameC", "gameCL", "gameCF"]),
    monthNames() {
      return [
        this.$t("LanguageEn.month1"),
        this.$t("LanguageEn.month2"),
        this.$t("LanguageEn.month3"),
        this.$t("LanguageEn.month4"),
        this.$t("LanguageEn.month5"),
        this.$t("LanguageEn.month6"),
        this.$t("LanguageEn.month7"),
        this.$t("LanguageEn.month8"),
        this.$t("LanguageEn.month9"),
        this.$t("LanguageEn.month10"),
        this.$t("LanguageEn.month11"),
        this.$t("LanguageEn.month12"),
      ];
    },
  },
};
</script>

<style scoped>
.navDiv1 {
  width: 100%;
  height: auto;
  color: white;
}

.nav-item {
  font-size: small;
}
.nav-link {
  height: 40px;
  color: white !important;
  text-align: center;
}

.leftEst {
  margin-left: 5px;
}

#routerLink1 {
  padding-top: 7%;
  padding-left: 0px !important;
  display: inline-block;
  text-decoration: none;
  width: 110px;
  height: 35px !important;
  color: white;
  text-align: center !important;
  font-weight: 550;
}
#routerLink1 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink1 .navbar-nav li > a:focus {
  color: #fff;
  font-weight: 550;
}

#routerLink1 .navbar-nav li.active > a.active {
  background-color: red;
  color: white;
}
.router-link-active {
  border-bottom: solid 3px #1c5e20;
}
.kek1:hover {
  color: #d04959 !important;
}
.kek2:hover {
  color: #43a047 !important;
}
.kek3:hover {
  color: #f0af49 !important;
}

/* Navbar link underline */

.gamesNav1 {
  background: #2c2d31 !important;
  padding: 0 !important;
  padding-top: 10px !important;
  margin-bottom: 5px !important;
  width: 100%;
  /* margin-left: 6px; */
}

#topheader1 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader1 .navbar-nav li > a:focus {
  color: #fff !important;
}

#topheader1 .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

@media only screen and (max-width: 600px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 600px) {
  .MobileShow {
    display: none;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1200px) {
  #routerLink1 {
    padding-top: 10%;
    padding-left: 0px !important;
    display: inline-block;
    text-decoration: none;
    width: 64px;
    height: 40px !important;
    color: white;
    text-align: center !important;
    font-weight: 550;
  }
  .gamesNav1 {
    background: #2c2d31 !important;
    padding: 0 !important;
    padding-top: 10px !important;
    margin-bottom: 5px !important;
    width: 100%;
    /* margin-left: 6px; */
  }
}
</style>

<style>
.b-form-datepicker > button {
  background: none !important;
  border: none !important;
}
</style>
